import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=dd0be0ae&scoped=true&"
import script from "./Entrance.vue?vue&type=script&lang=js&"
export * from "./Entrance.vue?vue&type=script&lang=js&"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=dd0be0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0be0ae",
  null
  
)

/* custom blocks */
import block0 from "./Entrance.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports